<template>
  <div class="asc-filter-legend">
    <asc-accordion :value="0">
      <asc-accordion-item first>
        <template slot="header">
          <div class="asc-filter-legend--header">
            <div class="asc-filter-legend--header-title">Legend</div>
            <template v-if="tooltip.length">
              <asc-tooltip
                class="asc-filter-legend--header-tooltip"
                :tooltip="tooltip"
                bottom
                is-icon-tooltip
                :max-width="'300'"
              >
                <span class="asc-icon">
                  <v-icon class="icon-info" :size="20">mdi-information</v-icon>
                </span>
              </asc-tooltip>
            </template>
          </div>
        </template>
        <v-row no-gutters>
          <v-col
            v-for="(item, index) in items"
            :key="index"
            :cols="getColumnCount(item.column)"
            :class="[
              getColumnClass(item.column),
              item.borderRight ? 'asc-filter-legend--border-right' : null,
            ]"
          >
            <div
              :class="[
                item.paddingLeft ? 'asc-filter-legend--col-padding-left' : null,
              ]"
            >
              <asc-legend-list
                filter
                :header="item.header"
                :multiple-columns="item.multipleColumns"
                :items="item.items"
                :items-selected="itemsSelected"
                :on-item-click="onItemClick"
              ></asc-legend-list>
            </div>
          </v-col>
        </v-row>
      </asc-accordion-item>
    </asc-accordion>
  </div>
</template>

<script>
import AscAccordion from '@/components/atoms/AscAccordion'
import AscAccordionItem from '@/components/atoms/AscAccordionItem'
import AscTooltip from '@/components/atoms/AscTooltip'
import AscLegendList from '@/components/molecules/AscLegendList'

export default {
  name: 'AscFilterLegend',

  components: {
    AscAccordion,
    AscAccordionItem,
    AscLegendList,
    AscTooltip,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    itemsSelected: {
      type: Array,
      default: () => [],
    },
    onItemClick: {
      type: Function,
      default: () => {},
    },
    tooltip: {
      type: String,
      default: '',
    },
  },

  methods: {
    getColumnCount(number) {
      return number || 12
    },

    getColumnClass(number) {
      if (number) {
        return `mb-${number}`
      }

      return `mb-12`
    },
  },
}
</script>

<style lang="scss">
.asc-filter-legend {
  .asc-label {
    font-size: 13px;
  }

  .asc-filter-legend--header {
    .asc-filter-legend--header-title {
      display: inline-block;
      vertical-align: middle;
    }

    .asc-filter-legend--header-tooltip {
      display: inline-block;
      vertical-align: middle;
      margin-left: 4px;

      .icon-info {
        color: $accent-500 !important;
        display: inline-block;
        font-size: $font-size-lrg;
      }
    }
  }

  .asc-filter-legend--border-right {
    border-right: 2px solid #bebebe;
  }

  .asc-filter-legend--col-padding-left {
    padding-left: 16px;
  }

  .col {
    margin-bottom: 0 !important;
  }
}
</style>
